export const IS_ANDROID = /(android)/i;
export const IS_IOS = /iPad|iPhone|iPod/;
export const ALPHANUMERIC_CHARACTERS = /^[a-z0-9]+$/i;
export const ALPHANUMERIC_PATTERN = '^[A-Za-z0-9]+$'; // HTML5 Input Pattern
export const NUMERIC_PATTERN = '^[0-9]+$';
export const DATE_MM_DD_YYYY = /((((0[13578]|1[02])\/(0[1-9]|1[0-9]|2[0-9]|3[01]))|((0[469]|11)\/(0[1-9]|1[0-9]|2[0-9]|3[0]))|((02)(\/(0[1-9]|1[0-9]|2[0-8]))))\/(19([6-9][0-9])|20([0-9][0-9])))|((02)\/(29)\/(19(6[048]|7[26]|8[048]|9[26])|20(0[048]|1[26]|2[048])))/;
export const EMAIL_PATTERN =  /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const USA_PHONE_PATTERN =  '((\\(\\d{3}\\) ?)|(\\d{3}-))?\\d{3}-\\d{4}';
export const GENERIC_PHONE_PATTERN =  /^\d{10,20}$/;
export const USA_POSTAL_CODE_PATTERN =  '^([0-9]{5})(?:[-\s]*([0-9]{4}))?$';
export const CAN_POSTAL_CODE_PATTERN = /^[ABCEGHJKLMNPRSTVXY]\d[A-Z] ?\d[A-Z]\d$/;
export const PR_POSTAL_CODE_PATTERN = /^\d{5}$/;
export const UPLOAD_DOCUMENT_EXTENSION_PATTERN = /^.*(jpg|JPG|gif|GIF|png|PNG|pdf|PDF|jpeg|JPEG)$/
export const WHITESPACE = /\s+/g;
